/* Scoped image viewer. No product selection, cart, price or inventory writes. */
if (!customElements.get('hf-case-pattern-viewer')) {
  customElements.define('hf-case-pattern-viewer', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound) return;
      this.dataset.bound = 'true';
      const open = this.querySelector('[data-cloth-open]');
      const dialog = this.querySelector('dialog');
      const scale = this.querySelector('[data-cloth-scale]');
      if (!open || !dialog || !dialog.showModal) return;
      const reset = () => {
        dialog.classList.remove('is-enlarged');
        scale.setAttribute('aria-pressed', 'false');
        scale.textContent = '柄・縁をさらに拡大';
      };
      open.addEventListener('click', event => { event.preventDefault(); reset(); dialog.showModal(); });
      this.querySelector('[data-cloth-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { reset(); open.focus({preventScroll:true}); });
      scale.addEventListener('click', () => {
        const enlarged = dialog.classList.toggle('is-enlarged');
        scale.setAttribute('aria-pressed', String(enlarged));
        scale.textContent = enlarged ? '全体表示に戻す' : '柄・縁をさらに拡大';
      });
    }
  });
}

